<template>
	<div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
		<TitleTextContent
			:titleText="newsHeaderTitle"
            :subTitleText="'What’s in the news? Project Spectrum keeps an eye on the latest cybersecurity tech trends, emerging technologies, compliance standards, cyber threats, and much more! Check out the latest news from around the web.'"
		/>
		<router-link
            v-if="isRecentNews"
            :to="{
              name: 'cybercorner',
            }"
        >
            <v-btn
              rounded
              large
              dark
			  class="mt-4"
              :color="'#424EC4'"
            >
              Back to Cyber Corner
            </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->
		<!-- Blog Grid Section Start -->
		<section class="section p-0 mt-5 section-content">
			<div class="container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5">
				<div class="w-100 d-flex justify-content-center section-title">
					<span>STAY UP TO DATE</span>
				</div>

				<div v-if="totalRows > 0" class="mb-5">
					<SearchControlWidget
						:inputTextPlaceholder="'Enter news title here'"
						:searchControlHeight="'100px'"
						:searchQueryInputHandler="updateSearchQuery"
					/>
				</div>

				<div class="blog-post-grid">
					<div class="row mb-4">
						<!-- Start Blog Item -->
						<NewsCard
							v-for="item in displayedNewsItems"
							:key="item.id"
							:newsItem="item"
							:newsPage="currentPage"
							:query="searchQuery"
							:isRecentNews="isRecentNews"
						/>
						<!-- End Blog Item -->
					</div>
				</div>

				<div v-if="(totalRows > 0) && (totalRows > perPage)" class="mb-5">
					<b-pagination
						class="m-0"
						id="news-pagination"
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="center"
						@page-click="pageClicked"
					></b-pagination>
				</div>
  
				<div v-if="displayedNewsItems.length === 0" style="height: auto;" class="row m-0 w-100 mb-4">
					<div class="col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center" v-html="newsItems.length === 0 
					? `There are no blogs available within the last six months` 
					: `There are no blog items available for the blog search: 
						<br>
						&quot${searchQuery}&quot
						`
					">
					</div>
            	</div>

				<div v-if="isRecentNews" class="d-flex flex-row justify-content-center mb-5">
					<v-btn
						rounded
						large
						dark
						:color="'#424EC4'"
						width="240"
						@click="goToNewsArchives"
					>
						View News Archives
					</v-btn>
				</div>
				<div v-else class="d-flex flex-row justify-content-center mb-5">
					<v-btn
						rounded
						large
						dark
						:color="'#424EC4'"
						width="240"
						@click="goToRecentNews"
					>
						Back To Recent
					</v-btn>
				</div>
			</div>
		</section>
		<!-- Blog Grid Section End -->
	</div>
</template>
<script>
import debounce from "debounce";
import { BPagination, BFormInput } from "bootstrap-vue";
import NewsCard from "../components/news/newsCard.vue";
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from "./library/widgets/title-text-content.vue";
import SearchControlWidget from './library/widgets/search-control-widget.vue';
import { EventBus } from '../utils/eventBus';
export default {
	name: "news",
	components: {
		BPagination,
		BFormInput,
		NewsCard,
		PageHeader,
		PageHeaderTitleContent,
		TitleTextContent,
		SearchControlWidget,
	},
	props: {
        newsHeaderTitle: String,
        newsItems: Array,
        isRecentNews: {
            type: Boolean,
            default: false,
        },
	},
	data() {
		return {
			searchQuery: null,
			currentPage: 1,
			perPage: 9,
			isQueryFromUrl: false,
		};
	},
	computed: {
		newsItemsFromSearchQuery() {
			if (this.searchQuery) {
				return this.newsItems.filter((item) => {
					return this.searchQuery
						.toLowerCase()
						.split(" ")
						.every(
							(v) =>
								item.article.title.toLowerCase().includes(v)
						);
				});
			} else {
				return this.newsItems;
			}
		},
		displayedNewsItems() {
			return this.newsItemsFromSearchQuery.slice(
				(this.currentPage - 1) * this.perPage,
				this.currentPage * this.perPage
			);
		},
		totalRows() {
			return this.newsItemsFromSearchQuery.length;
		},
	},
	methods: {
		pageClicked(bvEvent, page) {
			const params = this.searchQuery !== null || this.searchQuery !== "null" || this.searchQuery?.trim() === ""
							? 
								[
									{ param: 'newsPage', value: page }
								]
							: 
								[
									{ param: 'newsPage', value: page },
									{ param: 'query', value: this.searchQuery }
								];
			this.updateUrlQueryParam(
				this.isRecentNews ? '#/news' : '#/newsArchives', 
				params
			);

			// window.scrollTo({ top: 0, behavior: "smooth" });
			setTimeout(() => {
			document
				.getElementById("search-query-control")
				.scrollIntoView({ behavior: "smooth", block: "start" });
			}, 500);
		},
		updateSearchQuery(searchText) {
        	this.searchQuery = searchText;
      	},
		goToNewsArchives(){
			this.$router.push("newsArchives");
		},
		goToRecentNews(){
			this.$router.push("news");
		},
	},
	mounted() {
        const urlDomain = this.isRecentNews ? '/#/news?' : '/#/newsArchives?';
        const urlParams = new URL( window.location.href.replace(urlDomain, '?') );

        const newsPage = urlParams.searchParams.get('newsPage');
        const query = urlParams.searchParams.get('query');

        this.isQueryFromUrl = query != undefined || query != null || query?.trim().length !== '';
        this.currentPage = newsPage ? parseInt(newsPage) : 1;
        EventBus.$emit("update-search-query", query);
	},
	watch: {
		searchQuery(newValue) {
			if(!this.isQueryFromUrl) {
				this.currentPage = 1;
			}
  
			debounce(
				() => {
					this.updateUrlQueryParam(
						this.isRecentNews ? '#/news' : '#/newsArchives', 
						[
							{ param: 'newsPage', value: this.currentPage }, 
							{ param: 'query', value: newValue } 
						]
					);
				}, 
				1000, 
				{ immediate: false }
			).call(this);

        	this.isQueryFromUrl = false;
      },
	}
};
</script>
<style scoped>
#news-pagination li {
	margin: 0px;
}

.empty-blog-message {
    font-family: Rajdhani;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    color: #272727;
    word-break: break-all;
}
</style>
